import {useExtensionEditDrawer} from "@/pages/extensions/components/ProviderExtensionEdit.tsx";
import {Transition} from "@headlessui/react";
import {Extension} from "@/types/extenions.ts";
import {XMarkIcon} from "@heroicons/react/24/outline";
import {Button} from "@/components/ui/button.tsx";
import {useEffect, useState} from "react";
import {EditDrawerForm} from "@/pages/extensions/components/EditDrawerForm.tsx";

export function EditDrawer() {

    const [open, setOpen] = useState(false);
    const {isOpen, close, extension: _extension} = useExtensionEditDrawer()
    const extension = _extension as Extension;

    useEffect(() => {
       setOpen(isOpen)
    }, [isOpen]);

    return (
        <Transition
            show={open}
            as="div"
            className="flex flex-col transition-all fixed top-[82px] w-[468px] end-0 bg-white border-s border-gray-200 z-10 h-[calc(100vh-82px)]"
            enterFrom="-me-[468px]"
            enterTo="me-0"
            leaveFrom="-me-[468px]"
            leaveTo="me-0"
        >
            {isOpen && extension && (
                <>
                    <header className="px-4 py-4 border-b border-gray-200 flex justify-between items-center">
                        <div>
                            ערוך את שלוחה: <span className="font-medium">{extension.name ?? extension?.path}</span>
                        </div>
                        <div>
                            <Button className="rounded-full" variant="ghost" size="icon-sm" onClick={close}>
                                <XMarkIcon className="!size-5 text-gray-400"/>
                            </Button>
                        </div>
                    </header>

                    <div className="p-2 flex justify-center">
                        <Button asChild className="rounded-full w-[80%] h-8 bg-light-blue-50" variant="outline">
                            <a href={`/learning/sclass/${extension.id}/change/`}>
                                עבור לכל ההגדרות שלוחה
                            </a>
                        </Button>
                    </div>

                    <EditDrawerForm key={extension.id}/>
                </>
            )}
        </Transition>
    )
}